/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyPipedriveIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-pipedrive" */ './utils').then((m) => m.PipedriveIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/pipedrive/icon' },
);

const LazyPipedriveSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-pipedrive-search-result" */ './utils').then(
			(m) => m.PipedriveSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/pipedrive/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const PipedriveIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyPipedriveIconComponent />
	</Suspense>
);

export const PipedriveSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyPipedriveSearchResultIconComponent />
	</Suspense>
);
